/**
 * VERSIONE LIBRERIA 2
 */
var RenderFaicon = Render.extend({

    prefix : 'fa-' ,
    _oldIcon : null,
    type : 'faicon',
    classData : 'faicon',
    classTemplate : 'faicon',
    _renderView : function(jQe) {
        var self = this;
        var icon = self.prefix+self.value;
        var valueIcon = self.value;
        var viewicon = jQe.find('.selected-icon');
        viewicon.addClass(icon);
        self._oldIcon = valueIcon;
    },
    _finalizeView : function() {

    },
    _renderEdit : function(jQe) {
        var self = this;
        var icon = self.prefix+self.value;
        var valueIcon = self.value;
        var el = jQe.find('[data-control]');
        el.attr("name", self.key);
        el.attr("value", valueIcon);
        var viewicon = jQe.find('.selected-icon');
        viewicon.addClass(icon);
        self._oldIcon = valueIcon;
    },
    _finalizeEdit : function() {
        var self = this;
        $(self.container).find('[data-button_faicon]').click(function () {
            $.get(Facade.getUrl("/faiconsjs"), {},function (html) {
                self._showDialog(html);
            });
        })
    },
    _showDialog : function (html) {
        var self = this;

        var icon = self.prefix+self._oldIcon;
        var valueIcon = self._oldIcon;


        $('#faicon_dialog').find('.currentIcon').addClass(icon);
        $('#faicon_dialog').find('.selectedIcon').addClass(icon);
        $('#faicon_dialog').find('#faicons').html(html);

        $('#faicon_dialog').find('.select-fa-icon').click(function() {
            var currentValueIcon = $(this).attr('title').substr(self.prefix.length);
            var currentIcon = self.prefix+currentValueIcon;
            console.log(currentIcon);
            $('#faicon_dialog').find('input[name="selectedIcon"]').val(currentValueIcon);

            $('#faicon_dialog').find('.selectedIcon').removeClass(icon);
            $('#faicon_dialog').find('.selectedIcon').addClass(currentIcon);

            //self._oldIcon = currentIcon;

        });
        $('#faicon_dialog').modal('show').ok(function () {
            var value = $('#faicon_dialog').find('input[name="selectedIcon"]').val();
            var el = $(self.container).find('input[name="'+self.key+'"]');
            el.attr("value",value);
            var viewicon = $(self.container).find('.selected-icon');
            viewicon.removeClass(icon);
            viewicon.addClass(self.prefix+value);
            self._oldIcon = value;
        });


    }
});
